export default {"src":"/_next/static/media/logo-powered-by-autopass.8f52b0c6.svg","height":15,"width":109,"blurWidth":0,"blurHeight":0};